import { Component, OnInit } from '@angular/core';
import { BookstoreService } from 'src/app/services/bookstore/bookstore.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-stationary-sell-report',
  templateUrl: './stationary-sell-report.component.html',
  styleUrls: ['./stationary-sell-report.component.css']
})
export class StationarySellReportComponent implements OnInit {

  ClassList:any=[];
  SectionList:any=[];
  StudentList:any=[];
  StationarySellList:any=[];

  constructor(private bookstoreservice: BookstoreService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  InventoryModel = {
    ClassID: 0,
    SectionID: 0,
    StudentID: 0,
    IssueDate: '',
    DueDate: '',
    FromDate: '',
    ToDate: '',
    Print: '',
    PaymentModeID: '0',
   
}

ClearSearch() {
  this.StationarySellList = [];
  this.InventoryModel.ToDate = '';
  this.InventoryModel.FromDate = '';
  this.InventoryModel.DueDate = '';
  this.InventoryModel.IssueDate = '';
  this.InventoryModel.ClassID = 0;
  this.InventoryModel.SectionID = 0;
  this.InventoryModel.StudentID = 0;
  this.InventoryModel.PaymentModeID ='0';
};
GetStationarySell() {
  this.InventoryModel.Print = '';
  this.spinnerService.show();
  this.InventoryModel.FromDate =this.InventoryModel.FromDate!=null && this.InventoryModel.FromDate!=''?moment(this.InventoryModel.FromDate).format('DD-MMM-YYYY'):'';
  this.InventoryModel.ToDate =this.InventoryModel.ToDate!=null && this.InventoryModel.ToDate!=''?moment(this.InventoryModel.ToDate).format('DD-MMM-YYYY'):'';
  this.InventoryModel.IssueDate =this.InventoryModel.IssueDate!=null && this.InventoryModel.IssueDate!=''?moment(this.InventoryModel.IssueDate).format('DD-MMM-YYYY'):'';
  this.InventoryModel.DueDate =this.InventoryModel.DueDate!=null && this.InventoryModel.DueDate!=''?moment(this.InventoryModel.DueDate).format('DD-MMM-YYYY'):'';
 
  this.bookstoreservice.GetStationarySell(JSON.stringify(this.InventoryModel)).subscribe((data: any) => {
      this.StationarySellList = data.StationarySellList;
      this.spinnerService.hide();
      var TotalIssue = 0;
      var TotalPaid = 0;
      var PendingAmount = 0;
      var CollectionAmount = 0;
      if (this.StationarySellList != null) {
          for (var i = 0; i < this.StationarySellList.length; i++) {
              TotalIssue = TotalIssue + parseFloat(this.StationarySellList[i].PaidAmt);
              
              if (this.StationarySellList[i].PaymentDate!=null) {
                  TotalPaid = TotalPaid + parseFloat(this.StationarySellList[i].PaidAmt);
              }
          }
          this.SummaryModel.TotalIssue = this.globalHelper.Decimal(TotalIssue);
          this.SummaryModel.TotalPaid = this.globalHelper.Decimal(TotalPaid);
          this.SummaryModel.TotalRemaining = this.globalHelper.Decimal(TotalIssue - TotalPaid);
      }
     
  });
};


SummaryModel = {
  TotalIssue: 0,
  TotalPaid: 0,
  TotalRemaining: 0,       
}
  ngOnInit() {
    this.GetClass();
    this.GetSection();
    this.GetStudent();
  }

  GetClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;

    });
  };

  GetSection() {
    this.spinnerService.show();
    this.InventoryModel.SectionID = 0;
    this.InventoryModel.StudentID = 0;
    var ItemBo = {
      'ItemId': this.InventoryModel.ClassID
    }
    this.lookupservice.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.spinnerService.hide();

    });
  };

  GetStudent() {
    this.spinnerService.show();
    this.InventoryModel.StudentID = 0;
    var itemBo = {
      'ItemId': this.InventoryModel.ClassID,
      'ItemId2': this.InventoryModel.SectionID
    };
    this.lookupservice.GetLookupsList('Student', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.StudentList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  // Download

  XLSDownload() {
    this.InventoryModel.Print = 'XLS';
    this.bookstoreservice.GetStationarySell(JSON.stringify(this.InventoryModel)).subscribe((data: any) => {
        window.location = data.FilePath;
        this.InventoryModel.Print = '';
    });
};

// Print

PrintPages(ReceiptNo,PrintType, CopyType, Cancel) {
  if (Cancel == 'Y') {
    CopyType = 'C';
}
  var url = "issueitemprint?ReceiptNo=" + ReceiptNo+ "&PrintType=" + PrintType + "&CopyType=" + CopyType;
  this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

}

}
